import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { CartActions } from '@spartacus/cart/base/core';
import {
  AuthActions,
  AuthStorageService,
  AuthToken,
  BASE_SITE_CONTEXT_ID,
  OCC_USER_ID_CURRENT,
  RoutingService,
  SiteContextParamsService,
  StatePersistenceService,
  StorageSyncType,
  UserIdService,
} from '@spartacus/core';
import { BehaviorSubject, Subscription, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { PunchOutService } from 'src/app/shared/services/punchout.service';

@Component({
  selector: 'app-login-redirect',
  templateUrl: './login-redirect.component.html',
  styleUrls: ['./login-redirect.component.scss'],
})
export class LoginRedirectComponent implements OnInit, OnDestroy {
  busy$ = new BehaviorSubject(true);

  protected subscription = new Subscription();
  activeRouteSub: Subscription;

  constructor(
    private readonly activateRoute: ActivatedRoute,
    private readonly userIdService: UserIdService,
    private readonly store: Store,
    private readonly punchoutService: PunchOutService,
    private readonly authStorageService: AuthStorageService,
    private readonly routing: RoutingService,
    private readonly statePersistenceService: StatePersistenceService,
    protected siteContextParamsService: SiteContextParamsService
  ) {}

  ngOnInit(): void {
    this.activeRouteSub = this.activateRoute.queryParams
      .pipe(
        switchMap((params) => {
          return this.punchoutService
            .getPunchOutSessionData(params['sid'], params['key'])
            .pipe(
              tap((data) => {
                if (data.token.accessToken) {
                  this.statePersistenceService.syncWithStorage({
                    key: 'cart',
                    state$: of({
                      active: data.cartId,
                    }),
                    context$: this.siteContextParamsService.getValues([
                      BASE_SITE_CONTEXT_ID,
                    ]),
                    storageType: StorageSyncType.LOCAL_STORAGE,
                    onRead: (state) => this.onRead(state),
                  });

                  this.authStorageService.setToken({
                    access_token: data.token.accessToken,
                    token_type: data.token.tokenType,
                  } as AuthToken);
                  this.userIdService.setUserId(OCC_USER_ID_CURRENT);
                  this.store.dispatch(new AuthActions.Login());

                  this.busy$.next(false);
                  this.routing.go('/');
                }
              })
            );
        })
      )
      .subscribe();
  }
  ngOnDestroy(): void {
    this.activeRouteSub?.unsubscribe();
  }
  protected onRead(state: { active: string } | undefined) {
    this.store.dispatch(new CartActions.ClearCartState());
    if (state) {
      this.store.dispatch(new CartActions.SetActiveCartId(state.active));
    } else {
      this.store.dispatch(new CartActions.SetActiveCartId(''));
    }
  }
}
